import { WebFilterViewPage } from './../../pages/web-filter-view/web-filter-view';
import { WebWeeklyViewPage } from './../../pages/web-weekly-view/web-weekly-view';
import { NavController } from 'ionic-angular';
import { CoreProvider } from './../../providers/core-service/core-service';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the WebSidebarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'web-sidebar',
  templateUrl: 'web-sidebar.html'
})
export class WebSidebarComponent {

  @Input() pageActive: string;
  @Input() mobile: boolean;

  user: any = {};
  userphoto: string = '';

  appVersion: string = '1.1.7';

  privacy_label = 'PRIVACY';
  privacy_url = 'http://'

  constructor(private coreService: CoreProvider,
    private nav: NavController) {

    // used for an example of ngFor and navigation

    this.coreService.getUserData().filter(x => x).subscribe(user => {
      if (user) {
        this.user = user; 

        this.userphoto = this.user.photo;        
        this.userphoto = this.userphoto.replace('sz=50','sz=250');

        this.privacy_label = this.coreService.configuration.label_privacy;
        this.privacy_url = this.coreService.configuration.url_privacy;
      }
    }, err => {

      //console.log(err);
    });

  }

  logout() {
    this.coreService.logout().then(result => {
      //console.log('logout');
    });
  }

  openPage(page: string, travel: boolean = false) {

    if (page == 'week') {
      this.nav.setRoot(WebWeeklyViewPage, { resetDate: true, leaveTravel: travel });
    } else {
      this.nav.setRoot(WebFilterViewPage, { resetDate: true });
    }

  }


}



// WEBPACK FOOTER //
// ./src/components/web-sidebar/web-sidebar.ts